import { ImportCatalogState } from './state';

export const importCatalogInitialState: ImportCatalogState = {
  inProgress: false,
};
